/* set jquery globals */
const $ = window.jQuery;
const jQuery = window.jQuery;

function getSeconds(timestamp) {
	let time_array = timestamp.split(':');
	let seconds = parseInt(time_array[time_array.length - 1], 10);

	if(time_array.length > 1) {
		seconds += parseInt(time_array[time_array.length - 2], 10) * 60;
	}

	if(time_array.length > 2) {
		seconds += parseInt(time_array[time_array.length - 3], 10) * 60 * 60
	}
	
	return seconds;
}

if ($('[data-vidyard-control]').length) {
	let player = new Vidyard.player($('[data-vidyard-control]').attr('data-vidyard-control'));

	$('[data-timestamp]').click(function(e) {
		e.preventDefault();

		var $player = $('[data-vidyard-control]');
		var timestamp = getSeconds($(this).attr('data-timestamp'));

		player.seek(timestamp);
		player.play();

		$('html, body').animate({
			scrollTop: $player.offset().top - $('.page-header.autotrader').height()
		}, 300);
	}); 
}


